<div class="rating" [style.width.px]="width">
  <div>
    <div>(80 to 100)</div>
    <div>A</div>
    @if (_value >= 80) {
      <div>
        <i class="f-green fa fa-caret-left "></i>
        <span class="b-green">{{ _value + '%'}}</span>
      </div>
    }
  </div>
  <div>
    <div>(60 to 80)</div>
    <div>B</div>
    @if (_value >= 60 && _value < 80) {
      <div>
        <i class="f-lightgreen fa fa-caret-left "></i>
        <span class="b-lightgreen">{{ _value + '%'}}</span>
      </div>
    }
  </div>
  <div>
    <div>(40 to 60)</div>
    <div>C</div>
    @if (_value >= 40 && _value < 60) {
      <div><i class="f-yellow fa fa-caret-left "></i>
      <span class="b-yellow">{{_value + '%'}}</span>
    </div>
  }
</div>
<div>
  <div>(20 to 40)</div>
  <div>D</div>
  @if (_value >= 20 && _value <= 40) {
    <div>
      <i class="f-orange fa fa-caret-left "></i>
      <span class="b-orange">{{_value + '%' }}</span>
    </div>
  }
</div>
<div>
  <div>(0 to 20)</div>
  <div>E</div>
  @if (_value < 20 ) {
    <div>
      <i class="f-red fa fa-caret-left "></i>
      <span class="b-red">{{_value + '%'}}</span>
    </div>
  }
</div>
</div>
